<template>
  <div class="page">
    <c-source-form
      :columns="columns"
      :data="data"
      @submit="handleCreate"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class EditAdminUser extends Vue {

  data = {}

  get columns() {
    return createColumns.call(this)
  }

  async handleCreate(data) {
    const res = await this.$autoLoading(this.$request.post('/admin_users', data));
    this.$message.success('新建管理员完成');
    this.$router.push({ name: 'admin_users.show', params: { id: res.id } });
  }
}
</script>
